import React from 'react';
import { MdAdd, MdAccountTree, MdCheckCircleOutline } from 'react-icons/md';
import { ChipMenu } from '@aibuild/ui';

export interface ProcessSummary {
  id: string;
  name: string;
}

export interface CrumbProcessMenuProps {
  open: boolean;
  onClose: () => void;
  currentId: string;
  processes: ProcessSummary[];
  onPick: (id: string) => void;
  onNew: () => void;
  dataTestId?: string;
}

const PANEL_WIDTH = 248;

const CrumbProcessMenu: React.FC<CrumbProcessMenuProps> = ({
  open,
  onClose,
  currentId,
  processes,
  onPick,
  onNew,
  dataTestId = 'crumb-process-menu',
}) => {
  if (!open) return null;

  return (
    <ChipMenu
      onClose={onClose}
      align="center"
      width={PANEL_WIDTH}
      activeTreatment="subtle"
      ariaLabel="Switch process"
      dataTestId={dataTestId}
    >
      <ChipMenu.Item
        tone="accent"
        variant="button"
        icon={<MdAdd />}
        onClick={(e) => {
          e.stopPropagation();
          onClose();
          onNew();
        }}
        dataTestId={`${dataTestId}__new`}
      >
        New process
      </ChipMenu.Item>
      <ChipMenu.List dataTestId={`${dataTestId}__list`}>
        {processes.map((p) => {
          const active = p.id === currentId;
          return (
            <ChipMenu.Item
              key={p.id}
              isActive={active}
              icon={active ? <MdCheckCircleOutline /> : <MdAccountTree />}
              title={p.name}
              onClick={(e) => {
                e.stopPropagation();
                onClose();
                onPick(p.id);
              }}
              dataTestId={`${dataTestId}__item-${p.id}`}
            >
              {p.name}
            </ChipMenu.Item>
          );
        })}
      </ChipMenu.List>
    </ChipMenu>
  );
};

export default CrumbProcessMenu;
